import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Hero from './Components/Hero';
import Tabs from './Components/Tabs';
import Tab3 from './Components/Tab3';
 class Privasi extends Component {
  render() {
    return (
      <div className="privacy">
       <Hero
       title="Privasi"
       subtitle="Privasi yang kami gunakan dalam penggunaan data"
       />
       <Tabs></Tabs>
       <Tab3></Tab3>
      </div>
    )
  }
}

export default Privasi;